const styles = theme => ({
  socialShareContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/brands/Page/Sharing/styles.js